import React from "react";
import { Modal} from "react-bootstrap";

const LeaveParentDashboardModal = ({ show, handleClose, handleContinue }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton></Modal.Header>

      <Modal.Body className="text-center">
        <img
          src="https://yuvaquest-public-bucket-s3.s3.us-east-2.amazonaws.com/static/parentadmin/Group+163445.png"
          alt="Leaving"
          className="mb-3 img-fluid"
          style={{ maxHeight: "150px" }}
        />
        <h4 className="text-primary fw-bold">
          You are leaving the parent dashboard.
        </h4>
      </Modal.Body>
      <Modal.Footer className="border-0 justify-content-center">
        <button className="kidRegistrSubmtBtn" onClick={handleContinue}>
          Continue to Kid’s Dashboard
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default LeaveParentDashboardModal;
